import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GET_POSTS } from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import Loader from "../../common/Loader";
import { Avatar, Box, Button, Card, List, Stack, TextField } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { BIGrey } from "../../assets/helpers";
import { AddPostDialog } from "../common/AddPostDialog";
import { setShowReport, showAddPostModal } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import Post from "../new-community/Post";
import Pages from "../../constant/ReportModel";

const TradePostsSection = ({ id, scrollId }) => {
  const { loginData, showAddpost, multiLanguageData, selectedLanguage, reportSuccess, reportData } =
    useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const ENGLISH = English.Trades || {};
  const LanguageData = multiLanguageData?.Trades || {};
  const {
    BUTTON_ADD_POST = English.BUTTON_ADD_POST
  } = multiLanguageData?.Home || {};
  const {
    TEXT_WHAT_DO_TALK_ABOUT = ENGLISH.TEXT_WHAT_DO_TALK_ABOUT,
    TEXT_SHARE_YOUR_THOUGHTS = ENGLISH.TEXT_SHARE_YOUR_THOUGHTS,
    TEXT_POSTING_HERE_WILL_BE_SEEN = ENGLISH.TEXT_POSTING_HERE_WILL_BE_SEEN
  } = LanguageData;
  const dispatch = useDispatch();
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    getInitialData();
  }, []);

  useEffect(() => {
    if (reportSuccess !== true && reportData?.AppScreenId === Pages?.post?.id) {
      getInitialData();
      let reportObj = {
        showReport: false,
        recordId: 0,
        name: "",
        AppScreenId: 0
      };
      dispatch(setShowReport(reportObj));
    }
  }, [reportSuccess])

  const getInitialData = async () => {
    setIsLoading(true);
    await getPostsData(1, true);
    setIsLoading(false);
  };

  const getPostsData = async (pageNr, fristTimeApiCall = true) => {
    try {
      setAllDataLoaded(true);
      let res = await Getrequestcall(
        `${GET_POSTS}/${currentUserId}/7/${id}/${pageNr ?? 1}/25/${selectedLanguage}`,
        loginData?.accessToken
      );
      let resData = res?.data?.data ?? [];
      if (pageNr > 1) {
        setTimeout(() => {
          setPosts((prevProducts) => [...prevProducts, ...resData]);
        }, 500);
      } else {
        setPageNumber(1);
        setPosts(resData);
        if (fristTimeApiCall) {
          setHasData(resData?.length > 0);
        }
      }
    } catch (error) {
      console.log("getPostsData-> Error While Fetching Post: ", error);
    } finally {
      setAllDataLoaded(false);
      setIsLoading(false);
    }
  };

  const onWritePostClick = (event) => {
    event.target.blur();
    dispatch(showAddPostModal(true));
  };

  const handleCloseAddPostModal = () => {
    dispatch(showAddPostModal(false));
  };

  const handleAddPostClick = () => {
    dispatch(showAddPostModal(true));
  };

  const NoInformation = () => {
    return (
      <Stack sx={{ height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={handleAddPostClick}>
          {BUTTON_ADD_POST}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<ChatIcon className="emptydata-icon" />}
            firstText={TEXT_SHARE_YOUR_THOUGHTS}
          />
        </Box>
      </Stack>
    );
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const renderPosts = () => {
    return (
      <>
      {console.log("Post",posts)}
        <Stack gap={1.5}>
          <Card className="pagelist-content" sx={{ p: 1.5, backgroundColor: "#f2f2f2" }}>
            <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
              <Avatar alt="Profile Picture" src={loginData?.pictureUrl} />
              <TextField
                variant="outlined"
                fullWidth
                onClick={onWritePostClick}
                placeholder={TEXT_WHAT_DO_TALK_ABOUT}
              />
            </Stack>
          </Card> 
          {posts?.length > 0 ? (
            <InfiniteScroll
              dataLength={posts?.length}
              next={async () => {
                increaseOffset((pageNumber) => {
                  getPostsData(pageNumber);
                });
              }}
              hasMore={true}
              loader={
                !allDataLoaded ? null : (
                  <h4 style={{ display: "flex", justifyContent: "center" }}>
                    <Loader />
                  </h4>
                )
              }
              scrollableTarget={scrollId}>
              <List disablePadding>
                <Stack gap={1}>
                  {posts?.map((data) => (
                    <Post
                      postItem={data}
                      posts={posts}
                      setPosts={setPosts}
                      from="tradeDetail"
                    />
                  ))}
                </Stack>
              </List>
            </InfiniteScroll>
          ) : (
            <>
              <Stack
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
                style={{ color: BIGrey, padding: "30px" }}>
                {"No results found"}
              </Stack>
            </>
          )}
        </Stack>

      </>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderPosts() : <NoInformation />}
      </Card>
      {showAddpost && (
        <AddPostDialog
          appRecordId={id}
          appId={7}
          open={showAddpost}
          messageTitle={TEXT_POSTING_HERE_WILL_BE_SEEN}
          onClose={handleCloseAddPostModal}
          updatePosts={() => getPostsData(1)}
        />
      )}
    </Box>
  );
};

export default TradePostsSection;
